import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'permission-to-examine',
  templateUrl: './permission-to-examine.component.html',
})
export class PermissionToExamineComponent {

  title = 'permissionToExamine-jcps.title';
  progressBar = this.progress.permissionToExamine;
  permissionToExamine = true;

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) {}

  back() {
    this.router.navigate([this.navigation.permissionToExamine.back]);
  }

  next() {
    this.store.state.consent.permissionToExamine = this.permissionToExamine;
    this.store.state.consent.permissionToExamine = this.permissionToExamine;
    this.router.navigate([this.navigation.permissionToExamine.next]);
  }
}
